const OR = {
  "currency-saudi": "ریال سعودی",

  // Buttons Labels Repeated
  "modal-ok-btn": "ٹھیک ہے",
  "modal-close-btn": "بند کریں",

  // Navbar

  "arabic-key": "عربی",
  "english-key": "انگریزی",
  "urdu-key": "اردو",
  "hindi-key": "ہندی",
  "main-tab": "مرکزی",
  "laundry-owners-tab": "لانڈرومیٹ",
  "Delivery-representatives-tab": "ڈیلیوری کے نمائندے۔",
  "Accountant-account-tab": "حساب کتاب",
  "Earnings-account-tab": "آمدنی کا اکاؤنٹ",
  "admin-name": "منتظم",
  logout: "لاگ آوٹ",

  // ==========================================================================================================================================
  // LogIn
  "login-form-header": "لاگ ان کریں",
  "login-password-placeholder": "پاس ورڈ",
  "login-btn-text": "لاگ ان کریں",
  "login-user-name-placeholder": "اسم المستخدم",
  // ==========================================================================================================================================
  // Copy Rights Start
  "copy-rights-start-1": "کوئی سوال ہے؟",
  "copy-rights-start-2": "ہم سے رابطہ کریں۔",
  "copy-rights-start-3": "صفائی کی خدمات ایپ",
  "copy-rights-start-4": "| جملہ حقوق محفوظ ہیں",
  "copy-rights-start-5": "اسٹیک سافٹ کمپنی کے ذریعہ تیار کردہ",

  // ==========================================================================================================================================
  // Main
  "statistics-main-tab": "عام اعدادوشمار",
  "joins-requests-main-tab": "درخواستوں میں شامل ہوں۔",

  // Statistics
  "daily-done-orders-tab": "ڈیلی ڈون آرڈرز",
  "payed-money-tab": "ادائیگیاں",
  "most-used-laundry": "سب سے زیادہ استعمال شدہ لانڈرومیٹ",
  "Deliverymen-header": "ڈیلیوری مین",
  "Laundromats-header": "لانڈرومیٹ",
  "Number-of-completed-orders": "مکمل آرڈرز کی تعداد",
  "sort-label-statistics":
    "لانڈرومیٹس زیادہ سے زیادہ قابل اطلاق تک (مکمل آرڈرز پر منحصر ہے)",
  "number-of-accepted-orders": "منظور شدہ آرڈرز کی تعداد: ",
  "number-of-done-orders": "مکمل آرڈرز کی تعداد: ",
  "number-of-rejected-orders": "مسترد شدہ احکامات کی تعداد: ",

  // Join Requests
  "delivery-request-tab": "ڈیلیوری کی درخواستیں",
  "Laundry-Owner-request-tab": "لانڈرومیٹس کے مالکان کی درخواستیں۔",
  "accept-request": "قبول کریں۔",
  "reject-request": "رد کرنا",
  "detail-request-button": "آرڈر کی تفصیلات",
  "delivery-person-name": "ڈیلیوری مین کا نام",
  "laundry-name": "لانڈرومیٹ کا نام",
  "date-of-request": "آرڈر کی تاریخ",
  "phone-number": "فون نمبر",
  "relative-phone-number": "رشتہ دار فون نمبر",
  "relative-relation": "رشتہ دار رشتہ",
  nationality: "قومیت",
  "id-or-passport": "شناختی کارڈ یا پاسپورٹ",
  address: "رہائش کا شہر",
  city: "City",
  "bulding-number": "Bulding Number",
  "floor-number": "Floor Number",
  "vehicle-type": "گاڑی کی قسم",
  "vehicle-color": "گاڑی کا رنگ",
  "vehicle-num": "گاڑی کا نمبر",
  "vehicle-license": "گاڑی کا لائسنس",

  // ==========================================================================================================================================
  // Laundry Owners
  "date-of-join": "شمولیت کی تاریخ",
  "laund-details-btn": "لانڈرومیٹ کی تفصیلات",
  "all-laundries-header": "ہمارے ساتھ شامل ہونے والے تمام لانڈرومیٹس:",
  "all-laundromat-tap": "تمام لانڈرومیٹ",
  "offers-free-arrive-request-tap": "مفت ڈیلیوری آرڈرز",
  "offers-free-arrive-accepted-tap": "قابل قبول پیشکش",

  // Laundry Modal
  "laundry-services-label": "لانڈرومیٹ کی خدمات: ",
  "request-service-button": "سروس کی درخواست",
  "services-laundry-table-column": "خدمات دے دی گئیں",
  "size-laundry-table-column": "سرونگ سائز",
  "item-type-column": "چیز کی قسم",

  // Filter Laundry
  "Search-box-placeholder": "نام یا فون نمبر سے تلاش کریں۔",
  "choose-city": "ایک شہر منتخب کریں۔",
  "date-filter-new-to-old": "تازہ ترین سے پرانے تک",
  "date-filter-old-to-new": "قدیم سے جدید ترین تک",

  // ==========================================================================================================================================
  // All Delivery
  "all-delivery-header": "ہمارے ساتھ شامل ہونے والے تمام مندوبین:",
  "del-details-btn": "ڈیلیوری مین کی تفصیلات",

  // ==========================================================================================================================================
  // Earnings
  "receivables-required": "مطلوبہ قابل وصول",
  "commission-due": "کمیشن واجب الادا",
  "the-outcome": "نتیجہ",
  "outcome-zeroing": "نتیجہ زیرونگ",
  "info-1": "ہفتہ وار نتائج کا بٹن صرف جمعہ کو چلتا ہے۔",
  "info-2":
    "ڈیلیوری مین کو ملنے والا کمیشن ڈیلیوری مین کی طرف سے انجام دی جانے والی ہر سروس کے لیے واجب الادا کل کمیشن ہے۔.",
  "info-3":
    "ڈیلیوری مین کے لیے مطلوبہ وصولی کل ٹیکس ہیں جو ڈیلیوری مین کو ہر سروس کے لیے ایڈمنسٹریٹر کو ادا کرنا چاہیے۔",
  "info-4":
    "نتائج، مثبت نمبر کی صورت میں، ڈیلیوری مین کو ایڈمنسٹریٹر کو ادائیگی کرنی ہوگی، یا منفی نمبر کی صورت میں، ایڈمنسٹریٹر کو ڈیلیوری مین کے لیے ادائیگی کرنی ہوگی۔",
  "info-5":
    'جب ایڈمنسٹریٹر اور ڈیلیوری مین کے درمیان نتیجہ صفر ہو جاتا ہے تو ایڈمنسٹریٹر کو "نتیجہ زیرونگ" بٹن دبا کر نتیجہ صفر کرنا چاہیے۔',
  "Weekly-Outcomes": "ہفتہ وار نتائج",

  // ==========================================================================================================================================
  // Fees
  "label-1-fees":
    "ٹیکس کی قیمت جو ڈیلیوری مین کو ہر آرڈر پر ایڈمنسٹریٹر کو ادا کرنا ہوگی:",
  "label-2-fees": "ہر 1 کلومیٹر کے لیے ڈیلیوری مین کمیشن:",

  // ==========================================================================================================================================
  // Accountant
  "commissions-and-taxes-tap": "کمیشن اور ٹیکس",
  "earnings-calculate-tap": "آمدنی کا حساب لگائیں۔",

  // ==========================================================================================================================================
  // Offers Free Arrive
  "offer-det-btn": "پیشکش کی تفصیلات",
  "categories-label-offer": "پیشکش میں شامل صارفین کے زمرے:",
  "offer-time-label": "پیشکش کی مدت:",
  from: "سے:",
  to: "کو:",
  "zeroing-cost": "صفر کرنا",
  cost: "لاگت",
};

export default OR;
